import { Box, Grid, Typography } from "@mui/material";
import base from "../../assets/sustainabilityReport/baseSector.svg";
import envGrade from "../../assets/sustainabilityReport/envGrade.svg";
import govGrade from "../../assets/sustainabilityReport/governanceGrade.svg";
import socialGrade from "../../assets/sustainabilityReport/socialGrade.svg";
import { gradeColors } from "../sustainabilityIndex/gradeColors";
import "../Dashboard/dashboardStyles.css";
import "./createReportOutcomePreview.css";

const INDICATIVE_PILLARS = [
  {
    icon: base,
    title: "Base Performance",
    grade: "B",
  },
  {
    icon: envGrade,
    title: "Environment",
    grade: "B+",
  },
  {
    icon: socialGrade,
    title: "Social",
    grade: "A",
  },
  {
    icon: govGrade,
    title: "Governance & Economics",
    grade: "BC",
  },
];

const INDICATIVE_SCORE = 65;
const INDICATIVE_OVERALL_GRADE = "BC";

function pillarGradeColor(grade) {
  const letter = grade?.[0];
  return gradeColors[letter] || "#9b9b9b";
}

function sectorLabelForPreview(sector) {
  if (!sector) return "";
  if (typeof sector === "string") return sector;
  if (typeof sector === "object" && sector?.name) return sector.name;
  return "";
}

function buildReportLabel({ name, companyName, segment, year, sector }) {
  if (name?.trim()) return name.trim();
  const sectorText = sectorLabelForPreview(sector);
  const parts = [companyName, sectorText || segment, year].filter(Boolean);
  if (parts.length) return parts.join(" · ");
  return "Your Sustainability Index Report";
}

export default function CreateReportOutcomePreview({
  name,
  companyName,
  segment,
  year,
  sector,
}) {
  const reportLabel = buildReportLabel({
    name,
    companyName,
    segment,
    year,
    sector,
  });

  return (
    <Box className="create-report-outcome">
      <Box className="create-report-outcome__header">
        <Typography className="create-report-outcome__eyebrow">
          What you&apos;ll receive
        </Typography>
        <Typography className="create-report-outcome__subtitle">
          Indicative preview — your score card updates as you add data and
          complete vetting.
        </Typography>
      </Box>

      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12} md={5}>
          <Box
            className="verification_card create-report-outcome__score-card"
            sx={{ pointerEvents: "none", maxWidth: "100%" }}
          >
            <Box className="verification_card-heading_container">
              <Typography
                component="h3"
                className="verification_card-heading"
                sx={{ width: "100%", whiteSpace: "normal" }}
              >
                {reportLabel}
              </Typography>
              <Box
                className="verification_card-status_div"
                sx={{ backgroundColor: "#E8F5F4", color: "#28814D" }}
              >
                Preview
              </Box>
            </Box>

            <Box className="verification_card-progress_container">
              <span className="verification_card-percent">
                {INDICATIVE_SCORE}%
              </span>
              <span className="verification_card-percent-name">
                Sustainability Index Score Card
              </span>
            </Box>

            <Box className="verification_card-grading_container">
              <span className="verification_card-grade">
                {INDICATIVE_OVERALL_GRADE} Overall Grade
              </span>
              <span className="verification_card-grade_date">Sample output</span>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={7}>
          <Grid container spacing={1.5}>
            {INDICATIVE_PILLARS.map((pillar) => (
              <Grid item xs={6} sm={6} key={pillar.title}>
                <Box className="create-report-outcome__pillar">
                  <img src={pillar.icon} alt="" height={28} width={28} />
                  <Typography className="create-report-outcome__pillar-title">
                    {pillar.title}
                  </Typography>
                  <Typography
                    className="create-report-outcome__pillar-grade"
                    sx={{ color: pillarGradeColor(pillar.grade) }}
                  >
                    {pillar.grade}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
